import React, { useState, useEffect, useRef } from "react";
import { TableHead, Table, TableBody, TableCell, TableContainer, TableRow, TableFooter, TablePagination, Card, Box, Container, Chip, FormLabel } from "@mui/material";
import Api from "../../network/Api";
import TypingIndicator from "../Shared/TypingIndicator";
import { Lesson } from "../../types/Lessons";
import { NavLink } from "react-router-dom";
import { CommentButton, ItemButtonActions, StateButton } from "../Solutions/Buttons";
import { StartProps } from "./Start";
import dayjs from "dayjs";

const LessonsList = (props: StartProps & ItemButtonActions) => {

  const [lessons, setLessons] = useState<Array<Lesson>>();
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const scrollTopRef = useRef();

  useEffect(() => {
    Api.get(`/lessons?limit=${limit}&page=${page}`).then(result => {
      setLessons(result.items);
      setTotal(result.total);
      scrollTopRef.current?.scrollIntoView({ behavior: "smooth" });
    });
  }, [limit, page]);

  return <Box sx={{overflowY: 'auto', flexGrow: 1, width: "100%", py: 5}}>
    <Container maxWidth="xl">
      <Card sx={{p: "1.5rem !important"}}>
        <TableContainer sx={{width: '100%', overflowX: 'auto'}}>
          <Table>
            <TableHead ref={scrollTopRef}>
              <TableRow>
                <TableCell sx={{ position: "sticky", left: 0, zIndex: 1 }}><strong>Lesson learned</strong></TableCell>
                <TableCell align="center"><strong>Solution state</strong></TableCell>
                <TableCell align="center"><strong>Comments</strong></TableCell>
                <TableCell><strong>Root causes</strong></TableCell>
                <TableCell><strong>Origin</strong></TableCell>
                <TableCell><strong>Created at</strong></TableCell>
                <TableCell><strong>Last updated</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {lessons ? lessons.map((lesson) => {
                return <TableRow
                  key={lesson.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell sx={{ position: "sticky", left: 0, zIndex: 1, right: 0 }}>
                    <NavLink to={`/lessons/${lesson.id}`}>{lesson.headline}</NavLink>
                  </TableCell>
                  <TableCell align="center" width="15%"><StateButton lesson={lesson} onOpen={props.onOpen} /></TableCell>
                  <TableCell align="center" width="25%"><CommentButton lesson={lesson} size="small" onOpen={props.onOpen} /></TableCell>
                  <TableCell>{[...new Set(lesson.causes.map(cause => cause.category.name))].map(item => <Chip key={item} label={item} sx={{m: 0.5}} />)}</TableCell>
                  <TableCell align="center" width="25%"><FormLabel>{lesson.origin}</FormLabel></TableCell>
                  <TableCell><FormLabel>{dayjs.unix(lesson.created_at).format("lll")}</FormLabel></TableCell>
                  <TableCell><FormLabel>{dayjs.unix(lesson.updated_at).format("lll")}</FormLabel></TableCell>
                </TableRow>
              }) : <TableRow>
                <TableCell colSpan={5} sx={{justifyItems: "center", padding: 5}}>
                  <TypingIndicator />
                </TableCell>
              </TableRow>}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TablePagination 
                  count={total} 
                  page={page-1}
                  rowsPerPage={limit}
                  onPageChange={(e, page) => setPage(page+1)}
                  onRowsPerPageChange={e => setLimit(e.target.value)}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Card>
    </Container>
  </Box>
};

export default LessonsList;
